import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import './index.css';
var prefixCls = 'one-text';
var Text = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    style = props.style,
    numberOfLines = props.numberOfLines,
    children = props.children,
    onPress = props.onPress,
    onClick = props.onClick,
    rest = __rest(props, ["className", "style", "numberOfLines", "children", "onPress", "onClick"]);
  var handleClick = onClick || onPress;
  var lines = typeof numberOfLines === 'string' ? parseInt(numberOfLines, 10) : numberOfLines;
  var textString = '';
  if (children != null) {
    textString = Array.isArray(children) ? children.join('') : children.toString();
  }
  var classNames = [prefixCls, className];
  if (lines) {
    classNames.push("".concat(prefixCls, "--overflow-hidden"));
    if (lines === 1) {
      classNames.push("".concat(prefixCls, "--singleline"));
    } else {
      classNames.push("".concat(prefixCls, "--multiline"));
    }
  }
  return /*#__PURE__*/React.createElement("span", Object.assign({}, rest, {
    ref: ref,
    className: classNames.join(' '),
    style: Object.assign(Object.assign({}, style), {
      WebkitLineClamp: lines > 1 ? lines : undefined
    }),
    onClick: handleClick
  }), textString);
});
Text.displayName = 'Text';
export default Text;